import React from 'react';

import { SERVICE_CATEGORIES } from '@/components/atelier/serviceNavigation';

export default function MegaMenu({ onClose }) {
  return (
    <div className="absolute left-0 right-0 top-full bg-ivory border-b border-brown/10 shadow-card animate-fade-in z-30">
      <div className="max-w-container mx-auto px-[6vw] py-12 grid grid-cols-2 md:grid-cols-4 gap-10">
        {Object.entries(SERVICE_CATEGORIES).map(([category, items]) => (
          <div key={category}>
            <h4 className="font-serif text-[22px] text-warm-black mb-5 font-medium tracking-tight">
              {category}
            </h4>
            <ul className="space-y-3">
              {items.map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    onClick={onClose}
                    className="text-body-s text-muted hover:text-warm-black transition-all duration-200 inline-block hover:translate-x-1"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
}